export const options = [
  { label: "Water", value: 113 },
  { label: "Road", value: 112 },
  { label: "Rail", value: 114 },
  { label: "Air", value: 111 },
  { label: "Transport and Logistics", value: 21 },
  { label: "Translation services", value: 141 },
  { label: "Tourism", value: 22 },
  { label: "Telecommunications", value: 122 },
  { label: "Software, Hardware", value: 121 },
  { label: "Programming, Consultancy", value: 576 },
  { label: "Data processing, Web portals, E-marketing", value: 581 },
  { label: "Information Technology and  Telecommunications", value: 28 },
  { label: "Engineering", value: 35 },
  { label: "Business services", value: 25 },
  { label: "Environment", value: 33 },
  { label: "Service", value: 2 },
  { label: "Energy technology", value: 29 },
  { label: "Creative industries", value: 37 },
  { label: "Other", value: 3 },
  { label: "Wooden houses", value: 47 },
  { label: "Wooden building materials", value: 51 },
  { label: "Other (Wood)", value: 337 },
  { label: "Wood", value: 8 },
  { label: "Textile", value: 45 },
  { label: "Clothing", value: 44 },
  { label: "Textile and Clothing", value: 7 },
  { label: "Labelling and packaging printing", value: 145 },
  { label: "Book/Periodicals printing", value: 150 },
  { label: "Advertising", value: 148 },
  { label: "Printing", value: 5 },
  { label: "Plastic profiles", value: 560 },
  { label: "Plastics welding and processing", value: 53 },
  { label: "Manufacturing", value: 1 },
  { label: "Construction materials", value: 19 },
  { label: "Food and Beverage", value: 6 },
  { label: "Electronics and Optics", value: 18 },
  { label: "Bakery & confectionery products", value: 342 },
  { label: "Beverages", value: 43 },
  { label: "Other", value: 437 },
  { label: "Metal structures", value: 93 },
  { label: "Other", value: 508 },
  { label: "Boat/Yacht building", value: 269 },
  { label: "Ship repair and conversion", value: 230 },
  { label: "Aluminium and steel workboats", value: 271 },
  { label: "Maritime", value: 97 },
  { label: "Machinery", value: 12 },
  { label: "Machinery of machinery", value: 224 },
  { label: "Machinery equipment/tools", value: 91 },
  { label: "Machinery components", value: 94 },
  { label: "Project furniture", value: 99 },
  { label: "Outdoor", value: 341 },
  { label: "Other (Furniture)", value: 394 },
  { label: "Office", value: 392 },
  { label: "Living room", value: 101 },
  { label: "Kitchen", value: 98 },
  { label: "Children’s room", value: 390 },
  { label: "Bedroom", value: 385 },
  { label: "Bathroom/sauna", value: 389 },
  { label: "Furniture", value: 13 },
  { label: "Sweets & snack food", value: 378 },
  { label: "Milk & dairy products", value: 39 },
  { label: "Meat & meat products", value: 40 },
  { label: "Fish & fish products", value: 42 },
  { label: "Food and Beverage", value: 6 },
  { label: "Moulding", value: 57 },
  { label: "Plastic  processing technology", value: 559 },
  { label: "Plastic  goods", value: 556 },
  { label: "Packaging", value: 54 },
  { label: "Plastic and Rubber", value: 9 },
  { label: "Blowing", value: 55 },
  { label: "Gas, Plasma, Laser cutting", value: 69 },
  { label: "Repair and maintenance service", value: 227 },
  { label: "MIG, TIG, Aluminum welding", value: 66 },
  { label: "Construction of metal structures", value: 67 },
  { label: "Houses and buildings", value: 263 },
  { label: "Metal products", value: 267 },
  { label: "Metal works", value: 542 },
  { label: "Forgings, Fasteners", value: 62 },
  { label: "CNC-machining", value: 75 }
]
